/**
 * Booking-URL helper.
 *
 * `REACT_APP_DEMO_BOOKING_URL` may be an external Calendly link OR an internal
 * `/contact` route. For internal routes we append an `?intent=<slug>` so the
 * Contact form can pre-fill subject + starter message. For external URLs we
 * hand them back unchanged.
 */
const DEFAULT_URL = "/contact";

export function bookingUrl(intent = "walkthrough") {
  const raw = (process.env.REACT_APP_DEMO_BOOKING_URL || DEFAULT_URL).trim();
  if (!raw) return `/contact?intent=${encodeURIComponent(intent)}`;
  const isInternal = raw.startsWith("/");
  if (!isInternal) return raw;
  const sep = raw.includes("?") ? "&" : "?";
  return `${raw}${sep}intent=${encodeURIComponent(intent)}`;
}

export function isExternalBooking() {
  const raw = (process.env.REACT_APP_DEMO_BOOKING_URL || DEFAULT_URL).trim();
  return raw.startsWith("http://") || raw.startsWith("https://");
}
